(() => {
  const comicsPosterMedia = window.matchMedia ? window.matchMedia('(max-width: 768px)') : null;
  let comicsParallaxResizeTimeout = null;

  const syncComicsVideoPoster = (video) => {
    const desktopPoster = video.dataset.posterDesktop;
    const mobilePoster = video.dataset.posterMobile;
    const poster = comicsPosterMedia && comicsPosterMedia.matches ? mobilePoster : desktopPoster;

    if (poster && video.poster !== poster) {
      video.poster = poster;
    }
  };
    

  const syncComicsVideoPosters = (root = document) => {
    root.querySelectorAll('.comics-video video').forEach(syncComicsVideoPoster);
  };

  const initComicsVideos = (root = document) => {
    root.querySelectorAll('.comics-video').forEach((container) => {
      const video = container.querySelector('video');
      const playButton = container.querySelector('.comics-video__play');

      if (!video) {
        return;
      }

      syncComicsVideoPoster(video);

      if (container.dataset.comicsVideoInitialized === 'true' || !playButton) {
        return;
      }

      container.dataset.comicsVideoInitialized = 'true';

      const showVideoChrome = () => {
        container.classList.remove('is-playing');
        video.removeAttribute('controls');
      };

      const hideVideoChrome = () => {
        container.classList.add('is-playing');
        video.setAttribute('controls', 'controls');
      };

      playButton.addEventListener('click', (event) => {
        event.preventDefault();
        hideVideoChrome();

        const playPromise = video.play();

        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(showVideoChrome);
        }
      });

      video.addEventListener('play', hideVideoChrome);
      video.addEventListener('pause', showVideoChrome);
      video.addEventListener('ended', showVideoChrome);
    });
  };

  const initComicsParallax = () => {

    if (!window.gsap || !window.ScrollMagic) {
      return;
    }

    const speed = {
      0: -400,
      1: -200,
      2: window.isMobile ? -300 : -1000,
      3: -400,
      4: 0,
      2: window.isMobile ? -400 : -800,
      6: window.isMobile ? -300 : -1500
    }
    const fromMobile = {
      0: 0,
      1: 0,
      2: 400,
      3: 0,
      4: 0,
      5: 0,
      6: 0
    }

    const comicsParallaxController = new window.ScrollMagic.Controller();

    document.querySelectorAll('.comics__title, .comics__text--right,.comics__text--left, .comics__text--citation').forEach((element, index) => {
      const section = element.closest('.section--comics');

      if (!section) {
        return;
      }

      const tween = window.gsap.fromTo(element, {
        y: window.isMobile ? fromMobile[index] : 0,
      }, {
        y: speed[index] ?? -500,
        ease: 'none',
      });

      new window.ScrollMagic.Scene({
        triggerElement: section,
        triggerHook: 1,
        duration: 2000,
      })
        .setTween(tween)
        .addTo(comicsParallaxController);
    });
  };


  const initComics = (root = document) => {
    initComicsVideos(root);
    initComicsParallax();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initComics());
  } else {
    initComics();
  }

})();
